import React from "react";
import "./mMerch.css";

const MERCH_ITEMS = [
  {
    src: "/images/Black_unisex_design_05.png",
    name: "Reborn tee",
    description: "Heavyweight cotton with silkscreen print by Junglejules.",
  },
  {
    src: "/images/Black_unisex_design_16.png",
    name: "Frequency tee",
    description: "Psychedelic detailing and oversized fit.",
  },
];

const MMerch = () => (
  <div className="mmerch-container" id="merch">
    <section className="mmerch-card">
      <header className="mmerch-header">
        <span className="mmerch-kicker">Limited drops</span>
        <h1>Merch</h1>
        <p>Custom screen prints, small batches, shipped on request.</p>
      </header>

      <div className="mmerch-grid">
        {MERCH_ITEMS.map(({ src, name, description }) => (
          <article className="mmerch-item" key={name}>
            <div className="mmerch-media">
              <img src={src} alt={name} loading="lazy" />
            </div>
            <div className="mmerch-info">
              <h3>{name}</h3>
              <p>{description}</p>
            </div>
          </article>
        ))}
      </div>

      <footer className="mmerch-footer">
        <span>Order via</span>
        <a className="mmerch-email" href="mailto:dodsego@gmail.com">
          dodsego@gmail.com
        </a>
      </footer>
    </section>
  </div>
);

export default MMerch;